// extracted by mini-css-extract-plugin
export default {"btn":"Dropdown--btn--6P024","icon":"Dropdown--icon--WlM8b","list":"Dropdown--list--oPllt","item":"Dropdown--item--HJ65H"};